import React from 'react';
import { styled } from '@mui/system';
import MuiContainer from '@mui/material/Container';
import { CHILDREN_PROP_TYPES } from 'propTypes';

const StyledContainer = styled(MuiContainer)({
  '&.MuiContainer-maxWidthLg': {
    maxWidth: '1280px'
  }
});

export function Container({ children, ...rest }) {
  return (
    <StyledContainer disableGutters maxWidth="lg" {...rest}>
      {children}
    </StyledContainer>
  );
}

Container.propTypes = {
  children: CHILDREN_PROP_TYPES
};
